import { DefaultSelectData } from 'mbs-ui-shared@models/SelectData';
import { AzureInstanceStepValue } from 'wizards/models/azure-instance-models';
import { DiskInfoCommunication } from 'wizards/models/base/base-models/plan-disk-info-model';
import { SelectHostStepValue } from 'wizards/models/select-host-models';
import { ECInstanceStepValue } from 'wizards/models/target-or-temporary-instance-models';
import { RestoreAsDiskEnum, TypeDataStepValue } from 'wizards/models/type-data-models';
import { VmSettingsStepValue } from 'wizards/models/vm-settings-models';
import { EC2DataValue, EC2StepValue } from '../EC2-models';
import { AzureDataValue, AzureStepValue } from '../azure-models';
import { BaseRestoreFormsModel } from '../base/base-restore-forms-model';
import { EC2InstanceTypes } from '../base/other-base-models/EC2-instance-types-model';
import { PartitionsStepValue } from '../partitions-models';
import { TemporaryDataValue } from '../temporary-instance-models';

export class RestoreIbbFormModel extends BaseRestoreFormsModel {
  azureStep: AzureStepValue = {
    account: '',
    computerName: '',
    dataDiskName: '',
    locations: '',
    resourceGroup: '',
    vmSize: '',
    network: '',
    subnet: '',
    storage: '',
    container: '',
    bootDiagnosticStorage: '',
    valid: true
  };
  azureData: AzureDataValue = {
    accounts: [],
    locations: [],
    resourceGroups: [],
    vmSizes: [],
    networks: [],
    subnetItems: [],
    storageItems: [],
    containers: [],
    BDSItems: []
  };
  diskItems: DiskInfoCommunication[] = [];
  partitions: DefaultSelectData[] = [];
  selectHostStep?: SelectHostStepValue;
  vmSettingsStep?: VmSettingsStepValue;
  partitionsStep: PartitionsStepValue = { restorePartitions: [], convertToMBR: false, valid: true };
  typeDataStep: TypeDataStepValue;
  targetInstanceStep?: ECInstanceStepValue;
  temporaryInstanceStep?: ECInstanceStepValue;
  targetInstanceAzureStep?: AzureInstanceStepValue;
  temporaryInstanceAzureStep?: AzureInstanceStepValue;
  EC2: EC2StepValue = {
    account: '',
    region: '',
    availabilityZones: '',
    instanceType: 't1_micro',
    subnet: '',
    securityGroup: '',
    valid: true
  };
  temporaryData: TemporaryDataValue;
  EC2Data: EC2DataValue;

  constructor(public isNBF = false) {
    super(isNBF);
    const types = Object.keys(EC2InstanceTypes).filter((k) => typeof EC2InstanceTypes[k] === 'number' && k !== 'Unknown');
    this.destinationStep.isPhysical = false;
    this.destinationStep.selectedDisk = '';
    this.typeDataStep = { restoreAs: RestoreAsDiskEnum.Physical, createAMI: false, selectedFileFormat: this.fileFormats[0], valid: true };
    this.temporaryData = { accounts: [], regions: [], zones: [], types: types, subnetItems: [], securityGroups: [], amiItems: [] };
    this.EC2Data = { accounts: [], regions: [], zones: [], types: types, subnetItems: [], securityGroups: [] };
  }
}
